// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PiZE","navContent":"styles_navContent__1-stJ","applogo":"styles_applogo__80tDo","navLink":"styles_navLink__1DagU"};